// extracted by mini-css-extract-plugin
export default {"lds_dual_ring":"LoadingSpinner_lds_dual_ring__09XBU","loading_spinner_container":"LoadingSpinner_loading_spinner_container__eEjeS"};